import type { Snippet } from 'svelte';
import type { Action } from 'svelte/action';

export type TabsProps = {
  tabs: Snippet;
  panels: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
};

export type TabProps = {
  children: Snippet;
};

export type TabPanelProps = {
  children: Snippet;
};

export const tabsContextKey = Symbol('athena-tabs');

export type TabsContext = {
  activeTab: () => number;
  previousTab: () => number | undefined;
  setActiveTab: (tabNumber: number) => void;
  renderedTabs: number;
  renderedTabPanels: number;
  panelId: (tabNumber: number) => string;
  tabId: (tabNumber: number) => string;
  id: string;
};
